import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBasket, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useCart } from "@/context/CartContext";

const LINKS = [
  { label: "Our Story", href: "/#story" },
  { label: "Shop", href: "/#shop" },
  { label: "Honey 2027", href: "/#honey" },
  { label: "Contact", href: "/#contact" },
];

export function Header() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const go = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const id = href.replace("/#", "");
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FAF5EE]/90 border-b border-[#E6D7C3]" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-home-link">
          <Logo size={36} />
          <div className="leading-tight">
            <span className="font-serif-display font-bold text-lg text-[#2C221E] block">McGee's Bees</span>
            <span className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#B45309] hidden sm:block">
              A little sweet. A little wild.
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className="text-sm font-medium text-[#5A4D44] hover:text-[#B45309] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setOpen(true)}
            data-testid="cart-open-button"
            className="relative p-2.5 rounded-full hover:bg-[#F3EBE0] transition-colors"
            aria-label="Open basket"
          >
            <ShoppingBasket className="w-5 h-5 text-[#2C221E]" />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -top-0.5 -right-0.5 bg-[#D97706] text-white text-[10px] font-bold w-4.5 h-4.5 min-w-[18px] min-h-[18px] rounded-full flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2.5 rounded-full hover:bg-[#F3EBE0]"
            onClick={() => setMobileOpen((v) => !v)}
            data-testid="mobile-menu-button"
            aria-label="Menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden border-t border-[#E6D7C3] bg-[#FAF5EE] px-6 py-4 flex flex-col gap-4" data-testid="mobile-nav">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className="text-sm font-medium text-[#5A4D44]"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
